import { Pipe, PipeTransform } from "@angular/core";
import { SeparateurMillier } from './SeparateurMillier';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';

@Pipe({
  name:'dateStampDMY'
})
export class DatePipeService  implements PipeTransform {

  /**
   *
   */
  constructor(private _shared:SharedService) {
   
  }
  transform(value: number):string {
    if (value==0 ||value==NaN) return ''
   return this._shared.TimeStampToformatDMY(value)
  }
  
 
}